<template>
  <div class="" :style="width">
    <div class="header">
      <h2 class="">{{ title }}</h2>
    </div>

    <draggable class="inner" :list="value" group="notes">
      <div
        class="list-group-item item relative"
        v-for="(element, index) in value"
        :key="`${titlelc}-${getTime()}-${index}`"

      >
        <h3
          v-html="element.title"
          v-if="element.type == 'headline'"
          class=""
        ></h3>
        <p v-html="element.title" v-else class="content"></p>
        <v-icon @click="removeDialog(index)" class="black--text ma-1 delete"
          >mdi-close</v-icon
        >
      </div>
    </draggable>

    <div class="icons" v-if="!hideIcons">
      <v-btn @click="modalList" class="ma-1">Rename</v-btn>
      <v-btn @click="modalContent" class="ma-1">Add Content</v-btn>
      <v-btn @click="modalHeading" class="ma-1">Add Heading</v-btn>
      <v-icon @click="removeList(name)" class="white--text ma-1"
        >mdi-delete-forever</v-icon
      >
    </div>

    <v-dialog v-model="dialog" max-width="800">
      <v-card v-if="dialogMode == 'addContent'">
        <v-card-title>Add content</v-card-title>

        <v-card-text>
          <v-textarea
            color="amber"
            v-model="newNote"
            :rows="1"
            :autoGrow="true"
            :hide-details="true"
          />
        </v-card-text>

        <v-card-actions>
          <v-btn @click="addContent" color="amber">Save</v-btn>
        </v-card-actions>
      </v-card>

      <v-card v-if="dialogMode == 'addHeading'">
        <v-card-title>Add heading</v-card-title>

        <v-card-text>
          <v-textarea
            color="amber"
            v-model="newNote"
            :rows="1"
            :autoGrow="true"
            :hide-details="true"
          />
        </v-card-text>
        <v-card-actions>
          <v-btn @click="addHeading" color="amber">Save</v-btn>
        </v-card-actions>
      </v-card>

      <v-card v-if="dialogMode == 'editList'">
        <v-card-title>Add heading</v-card-title>

        <v-card-text>
          <v-textarea
            color="amber"
            v-model="newTitle"
            :rows="1"
            :autoGrow="true"
            :hide-details="true"
          />
        </v-card-text>
        <v-card-actions>
          <v-btn @click="editList" color="amber">Save</v-btn>
        </v-card-actions>
      </v-card>

      <v-card v-if="dialogMode == 'removeContent'">
        <v-card-title>Add heading</v-card-title>

        <v-card-text>
          <p>Delete item?</p>
        </v-card-text>
        <v-card-actions>
          <v-btn @click="removeItem" color="amber">Delete</v-btn>
          <v-btn @click="closeDialog" color="amber">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
// @ is an alias to /src
import draggable from "vuedraggable";
export default {
  name: "UserServiceCol",
  data() {
    return {
      newTitle: this.title,
      newNote: "",
      dialog: false,
      dialogMode: "",
      deleteObj: null,
    };
  },
  props: {
    value: Array,
    title: String,
    name: String,
    width: {
      type: Object,
      defaults: { width: '50%' }
    },
    hideIcons: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    value: {
      handler: function(val) {
        this.$emit("input", val);
      },
      deep: true,
    },
  },
  computed: {
    titlelc() {
      return this.title.toLowerCase();
    },
  },
  components: {
    draggable,
  },
  methods: {
    editList() {
      this.$emit("editList", {
        newTitle: this.newTitle,
        oldTitle: this.title,
        oldName: this.name,
      });
      this.dialog = false;
    },
    modalList() {
      this.dialogMode = "editList";
      this.dialog = true;
    },
    modalContent() {
      this.dialogMode = "addContent";
      this.dialog = true;
    },
    closeDialog() {
      this.dialog = false;
    },
    addContent() {
      let item = {
        index: this.value.length,
        id: this.value.length,
        title: this.newNote,
        type: "content",
      };
      this.value.push(item);
      this.newNote = "";
      this.dialog = false;
    },
    modalHeading() {
      this.dialogMode = "addHeading";
      this.dialog = true;
    },
    addHeading() {
      let item = {
        index: this.value.length,
        id: this.value.length,
        title: this.newNote,
        type: "headline",
      };
      this.value.push(item);
      this.newNote = "";
      this.dialog = false;
    },
    getTime() {
      return Math.round(new Date().getTime() / 1000);
    },
    removeList(name) {
      this.$emit("removeList", name);
    },
    removeDialog(index) {
      this.dialogMode = "removeContent";
      this.deleteObj = index;
      console.log(index)
      this.dialog = true;
    },
    removeItem() {
      // let item = this.value.find((ex) => ex.title == this.deleteObj);
      // let index = this.value.indexOf(item);
      this.value.splice(this.deleteObj, 1);
      this.deleteObj = null;
      this.dialog = false;
    },
  },
};
</script>

<style lang="scss">
.delete {
  position: absolute !important;
  right: 0;
  top: 0;
  font-size: 1rem;
}
  </style>
